import { Box, Grid, Typography } from "@mui/material";
import { fontFamilyAll, standardSubTextColor } from "../../Util/UtilColor";
import featureTruck from "../../Assets/red-truck.png";
import { features } from "../../Assets/data";


export default function FeaturesAndSkills() {
  const Styles = {
    subText: {
      color: standardSubTextColor,
      fontSize: { xs: "14px", sm: "15px", md: "16px" },
      lineHeight: 1.6,
      textAlign: "justify",
      px: { xs: 1, sm: 2 },
    },
    featureDiv: {
      padding: { xs: "15px", sm: "20px" },
      textAlign: "center",
    },
    icon: {
      width: "50px",
      height: "50px",
      marginBottom: "12px",
    },
  };



  return (
    <Box sx={{ marginBottom: { xs: "50px", sm: "70px", md: "90px" }, px: { xs: 2, sm: 4, md: 6 } }}>
      {/* Heading */}
      <Box sx={{ textAlign: "center", mb: { xs: 4, sm: 6 } }}>
        <Typography
          sx={{
            fontSize: { xs: "22px", sm: "28px", md: "40px" },
            fontWeight: 900,
            fontFamily: fontFamilyAll,
          }}
        >
          FEATURE
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "16px", sm: "18px", md: "24px" },
            fontWeight: 400,
            fontFamily: fontFamilyAll,
            color: "gray",
          }}
        >
          FEATURE AND SKILLS
        </Typography>
      </Box>

      {/* Content */}
      <Grid container spacing={4} alignItems="center">
        {/* Left Image */}
        <Grid item xs={12} md={5} sx={{ textAlign: "center" }}>
          <img
            src={featureTruck}
            alt="Feature Truck"
            style={{
              width: "80%",
              maxWidth: "320px",
              height: "auto",
            }}
          />
        </Grid>

        {/* Features */}
        <Grid item xs={12} md={7}>
          <Grid container spacing={{ xs: 3, sm: 4 }}>
            {features.map((f, i) => (
              <Grid item xs={12} sm={6} key={i}>
                <Box sx={Styles.featureDiv}>
                  <img src={f.icon} alt={f.title} style={Styles.icon} />
                  <Typography
                    sx={{
                      fontSize: { xs: "16px", sm: "18px", md: "22px" },
                      fontWeight: 600,
                      fontFamily: fontFamilyAll,
                      mb: 1,
                    }}
                  >
                    {f.title}
                  </Typography>
                  <Typography sx={Styles.subText}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
                    elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus
                    leo.
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
